import { render, staticRenderFns } from "./dataPrivilegeManageList.vue?vue&type=template&id=0ede6c61&scoped=true"
import script from "./dataPrivilegeManageList.vue?vue&type=script&lang=js"
export * from "./dataPrivilegeManageList.vue?vue&type=script&lang=js"
import style0 from "./dataPrivilegeManageList.vue?vue&type=style&index=0&id=0ede6c61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ede6c61",
  null
  
)

export default component.exports